import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { getSeasonsSelectors } from '../slices/gff/seasons/getSeasonsSlice';

export const farmsSelector = (growerId, seasonId) =>
  getSeasonsSelectors.farms(growerId, seasonId);

export const farmSelector = (growerId, seasonId, farmId) =>
  getSeasonsSelectors.farm(growerId, seasonId, farmId);

export const useFarmsSelector = (growerId, seasonId) => {
  const farms = useSelector(farmsSelector(growerId, seasonId));

  return useMemo(() => ({ farms }), [farms]);
};

export const useFarmSelectors = (growerId, seasonId, farmId) => {
  const farm = useSelector(farmSelector(growerId, seasonId, farmId));

  return useMemo(() => ({ farm }), [farm]);
};
